module.exports = __webpack_public_path__ + "static/media/17.84c224ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/17.png
// module id = 869
// module chunks = 0